var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9649 18.2984H4.03505C2.05763 18.2984 0.448914 16.6867 0.448914 14.7055V3.7549C0.448914 1.77372 2.05763 0.161568 4.03505 0.161568H14.9649C16.9423 0.161568 18.551 1.77372 18.551 3.7549V14.7055C18.551 16.6867 16.9423 18.2984 14.9649 18.2984ZM4.03505 1.00667C2.52263 1.00667 1.2928 2.23961 1.2928 3.75451V14.7051C1.2928 16.2204 2.52302 17.4525 4.03505 17.4525H14.9649C16.4773 17.4525 17.7071 16.22 17.7071 14.7051V3.7549C17.7071 2.23961 16.4769 1.00706 14.9649 1.00706H4.03505V1.00667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7559 13.8992C8.7559 13.8992 9.92923 10.9338 8.7559 9.90745C7.72954 9.00963 5.2641 9.90745 5.2641 9.90745V8.51529H8.7559V4.56078H10.1697V8.51529H13.7355V9.90745H10.1697V13.8992H8.7559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.094c33c7.svg";
export { ForwardRef as ReactComponent };